
export const environment = {
  production: true,
  routerBasename: null,
  pageTitle: 'Storyverse',
  serviceAddress: '',
  userServiceApi: 'metamask',
  adminApi: 'mock',
  metadataApi: 'rest',
  plotsApi: 'mbaas',
  analyticsApi: 'amp',
  chainalysisApi: 'mock',
  navbarApi: 'navbar',
  walletApi: 'navbar',
  writerApi: 'navbar',
  saleApi: 'navbar',
  ampKey: '332823be2ad5a8d547b1e5e942befc19',
  restMetadataUrl: 'https://meta.alpha.storyverse.xyz/a',
  openSeaUrl: 'https://opensea.io',
  openSeaContract: '0x3a7011e7e2b32c2b52f7de1294ff35d6ff20310f',
  introUrl: 'https://intro.alpha.storyverse.xyz',
  chainalysisUrl: 'https://api.chainalysis.com/api/kyt/v1/',
  chainalysisApiKey: 'e9a2a04ab126e27b40d67809fc8f3f4245cbf8b4934ec15a12933bd203a910be',
  mockLoadingMs: 500,
  forcePageState: 'soldOut422',
  mapsUrl: 'https://maps.alpha.storyverse.xyz',
  createUrl: 'https://d2wv16yj445s5m.cloudfront.net/index.html',
  viewUrl: 'https://d1qb7cmmizeqey.cloudfront.net/index.html',
  ethNetwork: 'homestead',
  serviceProxyUrl: 'https://blockchain.alpha.storyverse.xyz',
  plotsBaseURI: 'https://meta.alpha.storyverse.xyz/a',
  persistStoryServerPrefix: 'https://pipeline.alpha.storyverse.xyz/story/',
  persistPlotServerPrefix: 'https://pipeline.alpha.storyverse.xyz/plot/',
  captionContestUrl: 'https://intro.alpha.storyverse.xyz/caption-contest/alpha/',
  passthroughParams: [],
  appUrlOverride: false,
  templateApiPrefix: 'https://pipeline.alpha.storyverse.xyz/templates/visible/',
  assetsApiPrefix: 'https://pipeline.alpha.storyverse.xyz/assets/',
  foundersPassContract: '0x8F1Bc587FF2d87CfC0c5Db69a04D094c523008D4',
};
